@if (agent$ | async; as agent) {
  <!-- faq list -->
  @for (faq of agent.configuration.faq; track $index) {
    <details
      class="py-2 px-3 rounded-lg cursor-pointer focus-within:!bg-accent-600/10 focus-within:border-transparent bg-black/5 hover:bg-black/10 transition-all"
      [open]="expandedFAQ === $index"
      (click)="$event.preventDefault()"
    >
      <summary
        class="text-lg text-neutral-900/90 flex gap-1 items-center transition-all"
      >
        <input
          placeholder="Pergunta"
          [(ngModel)]="faq.question"
          class="flex-1 bg-transparent border-none p-0 font-bold placeholder:font-normal"
          (focus)="expandedFAQ = $index"
          (keydown.space)="$event.stopPropagation()"
        />
        <span
          class="material-symbols-rounded cursor-pointer"
          (click)="removeFAQ($index)"
          >delete</span
        >
      </summary>

      <input
        placeholder="Resposta"
        [(ngModel)]="faq.answer"
        class="w-full bg-transparent border-none p-0 mt-1"
      />
    </details>
  }

  <!-- add faq button -->
  <button
    class="!bg-transparent hover:!bg-black/5 !text-accent-600 border-dotted py-2 px-3 border-2 border-black/10 mt-2"
    (click)="addFAQ()"
  >
    <span class="material-symbols-rounded">add</span>
    Adicionar pergunta
  </button>
}
